import 'angular';

import { LaborItemsCtrl }    from './labor-items';
import { LaborItemsStates }  from './labor-items.states.ajs';

angular.module('workshop.laborItems', [])

.controller('laborItemsCtrl', LaborItemsCtrl)

.config(LaborItemsStates);